export default "__VITE_ASSET__9cfba497__"